<template>
  <div class="md:bg-main-bg flex justify-center min-h-screen">
    <div class="main-wrap flex flex-col">
      <div
        class="px-4 lg:px-0 font-medium h-24 flex flex-col justify-center items-start"
      >
        <div class="max-w-4xl mx-auto w-full">
          <div>
            <img src="/assets/images/LoanSpot-logo-alt.svg" />
          </div>
        </div>
      </div>
      <h2 class="max-w-sm mx-auto text-lg title">Please answer the following questions as truthfully as possible</h2>
      <div class="max-w-sm mx-auto px-4 md:px-0 mt-10 question-wrapper w-full">
        <div
          class="md:bg-white sm:p-6 rounded-lg mx-auto sm:pb-6 sm:border border-border relative"
        >
          <div v-if="questions[stage]" class="mt-4">
            <h3
              class="text-sm font-light working--title tracking-wide leading-snug"
            >
              {{ questions[stage].index }}. {{ questions[stage].value }}
            </h3>
            <div class="mt-8">
              <div
                v-if="
                  [
                    'psychometric',
                    'residentialStatus',
                    'residentialDuration',
                  ].includes(questions[stage].type)
                "
              >
                <a
                  v-for="(option, optionIndex) in questions[stage][
                    '__options__'
                  ]"
                  @click.prevent="
                    () =>
                      selectOption({
                        optionId: option.id,
                        questionId: questions[stage].id,
                      })
                  "
                  :key="optionIndex"
                  class="radio-wrap mt-2 cursor-pointer py-3 bg-main-bg rounded-lg border pl-6 flex items-center text-sm mb-3"
                  :class="[
                    answeredQuestions[questions[stage].id] == option.id
                      ? 'text-primary border-primary font-bold'
                      : 'text-title hover:text-primary border-border hover:border-primary',
                  ]"
                >
                  {{ option.value }}
                </a>
              </div>
              <div v-else class="flex flex-col input-wrap mt-4 md:mt-0">
                <div class="flex items-center w-full rounded-lg">
                  <select
                    class="mt-1 bg-transparent w-full h-full text-title border outline-none rounded-lg text-sm pl-4 minimal py-3 border-input-border hover:border-active focus:border-active"
                    @blur.prevent="
                      (e) =>
                        selectOptionFromDropdown(e, {
                          questionId: questions[stage].id,
                        })
                    "
                    v-model="industry"
                  >
                    <option :value="null" selected>Choose</option>
                    <option
                      v-for="(option, optionIndex) in questions[stage][
                        '__options__'
                      ]"
                      :key="optionIndex"
                      :value="option.id"
                    >
                      {{ option.value }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <div class="grid grid-cols-1 gap-4 mt-8">
              <button
                @click.prevent="next"
                class="btn flex items-center justify-center bg-primary w-full rounded-lg py-3 hover:bg-bg-hover text-white font-bold text-sm no-focus col-span-1 font-simple"
              >
                <span id="spin" slot="spin" class="animate-spin hidden">
                  <svg
                    width="28"
                    height="28"
                    viewBox="0 0 28 28"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M14 0C13.6228 0 13.3171 0.305746 13.3171 0.682927V7.51219C13.3171 7.88934 13.6228 8.19512 14 8.19512C14.3772 8.19512 14.6829 7.88934 14.6829 7.51219V0.682927C14.6829 0.305746 14.3772 0 14 0ZM4.58841 3.90549C4.41362 3.90549 4.2309 3.96421 4.09756 4.09756C3.83084 4.36427 3.83084 4.80188 4.09756 5.0686L8.93139 9.89177C9.19807 10.1584 9.62503 10.1585 9.89178 9.89177C10.1585 9.62506 10.1584 9.19808 9.89178 8.9314L5.06861 4.09756C4.93527 3.96421 4.76321 3.90549 4.58841 3.90549ZM23.4116 3.90549C23.2368 3.90549 23.0648 3.96421 22.9314 4.09756L18.1082 8.9314C17.8416 9.19809 17.8416 9.62507 18.1082 9.89177C18.3749 10.1585 18.8019 10.1585 19.0686 9.89177L23.9024 5.0686C24.1692 4.80189 24.1691 4.36426 23.9024 4.09756C23.7691 3.96421 23.5863 3.90549 23.4116 3.90549ZM0.682927 13.3171C0.305746 13.3171 0 13.6228 0 14C0 14.3772 0.305746 14.6829 0.682927 14.6829H7.51219C7.88934 14.6829 8.19512 14.3772 8.19512 14C8.19512 13.6228 7.88934 13.3171 7.51219 13.3171H0.682927ZM20.4878 13.3171C20.1107 13.3171 19.8049 13.6228 19.8049 14C19.8049 14.3772 20.1107 14.6829 20.4878 14.6829H27.3171C27.6943 14.6829 28 14.3772 28 14C28 13.6228 27.6943 13.3171 27.3171 13.3171H20.4878ZM9.41158 17.9055C9.23682 17.9055 9.06473 17.9749 8.93139 18.1082L4.09756 22.9314C3.83084 23.1981 3.83088 23.6357 4.09756 23.9024C4.36428 24.1692 4.80186 24.1692 5.06861 23.9024L9.89178 19.0686C10.1584 18.8019 10.1584 18.3749 9.89178 18.1082C9.75841 17.9749 9.58635 17.9055 9.41158 17.9055ZM18.5884 17.9055C18.4136 17.9055 18.2416 17.9749 18.1082 18.1082C17.8415 18.3749 17.8416 18.8019 18.1082 19.0686L22.9314 23.9024C23.1981 24.1692 23.6358 24.1692 23.9024 23.9024C24.1692 23.6357 24.1692 23.1981 23.9024 22.9314L19.0686 18.1082C18.9353 17.9749 18.7632 17.9055 18.5884 17.9055ZM14 19.8049C13.6228 19.8049 13.3171 20.1107 13.3171 20.4878V27.3171C13.3171 27.6943 13.6228 28 14 28C14.3772 28 14.6829 27.6943 14.6829 27.3171V20.4878C14.6829 20.1107 14.3772 19.8049 14 19.8049Z"
                      fill="white"
                      fill-opacity="0.7"
                    />
                  </svg>
                </span>
                <span id="check" slot="check" class="hidden mr-1">
                  <svg
                    width="14"
                    height="14"
                    viewBox="0 0 14 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M7.00016 13.6666C3.31816 13.6666 0.333496 10.6819 0.333496 6.99992C0.333496 3.31792 3.31816 0.333252 7.00016 0.333252C10.6822 0.333252 13.6668 3.31792 13.6668 6.99992C13.6668 10.6819 10.6822 13.6666 7.00016 13.6666ZM7.00016 12.3333C8.41465 12.3333 9.77121 11.7713 10.7714 10.7712C11.7716 9.77096 12.3335 8.41441 12.3335 6.99992C12.3335 5.58543 11.7716 4.22888 10.7714 3.22868C9.77121 2.22849 8.41465 1.66659 7.00016 1.66659C5.58567 1.66659 4.22912 2.22849 3.22893 3.22868C2.22873 4.22888 1.66683 5.58543 1.66683 6.99992C1.66683 8.41441 2.22873 9.77096 3.22893 10.7712C4.22912 11.7713 5.58567 12.3333 7.00016 12.3333ZM6.3355 9.66659L3.50683 6.83792L4.4495 5.89525L6.3355 7.78125L10.1062 4.00992L11.0495 4.95259L6.3355 9.66659Z"
                      fill="white"
                    />
                  </svg>
                </span>
                <span id="next" slot="value">
                  {{ questions[stage + 1] ? "Next" : "Complete" }}
                </span>
              </button>
              <button
                @click="stage > 0 ? (stage -= 1) : (stage += 1)"
                v-if="stage > 0"
                class="py-3 bg-main-bg border border-border text-title rounded-lg text-sm no-focus col-span-1 font-medium"
              >
                <!-- &#8592; -->
                Back
              </button>
            </div>
          </div>
        </div>
      </div>

      <response-modal
        id="response"
        v-show="isCompleted"
        :wrapperClass="['fixed h-screen z-50 top-0 left-0 right-0 bg-sec-bg']"
        modalClass="modal-wrap mx-auto bg-white rounded-lg flex flex-col items-center justify-center max-w-xs border border-border mx-auto w-full p-6"
        contentClass="flex flex-col items-center justify-center w-full"
        :modalTitle="responseSuccess.title"
      >
        <div class="mb-8" slot="modal-icon-success">
          <svg
            width="144"
            height="144"
            viewBox="0 0 144 144"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="72" cy="72" r="72" fill="#27BD8B" fill-opacity="0.08" />
            <circle cx="72" cy="72" r="56" fill="#CBEFE3" />
            <circle cx="72" cy="72" r="40" fill="#27BD8B" />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M54.5321 70.7144C53.6859 71.4244 53.5756 72.6859 54.2856 73.5321L64.8998 86.1816C65.3214 86.684 65.9374 86.9271 66.5454 86.893C66.5537 86.8925 66.5619 86.892 66.5702 86.8914C66.9784 86.8638 67.3818 86.7112 67.7192 86.4281L89.797 67.9026C90.6431 67.1926 90.7535 65.9311 90.0435 65.0849L88.8474 63.6595C88.1374 62.8133 86.8759 62.7029 86.0297 63.413L66.6091 79.7088L58.4759 70.016C57.7659 69.1698 56.5044 69.0595 55.6582 69.7695L54.5321 70.7144Z"
              fill="white"
            />
          </svg>
        </div>
        <button
          slot="cta"
          class="mt-6 py-3 bg-primary text-white w-full text-sm rounded-lg no-focus"
          @click.prevent="$router.replace('/')"
        >
          Continue
        </button>
      </response-modal>
    </div>
  </div>
</template>

<script>
import { AUTH_ROUTES } from "../constants";
import { ApiInstance } from "../utils";
import ResponseModal from "../components/partials/response-modal";
import { mapState } from "vuex";

export default {
  name: "Onboarding",
  props: [],
  components: {
    "response-modal": ResponseModal,
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (vm.user.filledPsychometric) {
        return next({ path: from.fullPath || "/" });
      }
      next();
    });
  },
  computed: {
    ...mapState({
      user: (state) => state.profile,
    }),
  },
  data() {
    return {
      great: "Great!",
      token: "",
      questions: [],
      answers: [],
      stage: 0,
      answeredQuestions: {},
      responseSuccess: {
        title: `You are all signed up`,
        text: `Thanks for taking time out to finish the test.`,
      },
      isCompleted: false,
      industry: null,
    };
  },
  async created() {
    this.questions = await this.getQuestions();
    if (this.questions.length > 0) {
      let obj = {};
      this.questions.forEach(
        (question) => (obj = Object.assign(obj, { [question.id]: null }))
      );
      this.answeredQuestions = Object.assign(
        {},
        this.answeredQuestions,
        Object.assign({ ...this.answeredQuestions, ...obj })
      );
    }
  },
  methods: {
    async next() {
      if (this.stage <= 9) {
        const currentQuestion = this.questions[this.stage];
        if (!this.answeredQuestions[currentQuestion.id]) {
          return this.$notie.alert({
            type: "error",
            text: "This question is required.",
            time: 2,
          });
        }
      }

      if (this.questions[this.stage + 1]) {
        this.stage += 1;
      } else await this.saveQuestions();
    },
    async saveQuestions() {
      if (this.answers.length !== this.questions.length) {
        return this.$notie.alert({
          type: "error",
          text: "Please fill out all the questions.",
          time: 3,
        });
      }
      const response = await ApiInstance.post("/question-answers", {
        answers: this.answers,
      });

      if (response.status) {
        this.isCompleted = true;
      }

      if (!response.status) {
        let message =
          response.error?.message ||
          "Could not complete your request, please retry.";
        if (
          [422, 400, 403].includes(response.error?.statusCode) &&
          response.error.fields
        ) {
          message = Object.values(response.error.fields)[0];
        }
        return this.$notie.alert({
          type: "error",
          text: message,
          time: 4,
        });
      }
    },
    selectOption(option) {
      this.answers[this.stage] = option;
      this.$set(
        this.answeredQuestions,
        Object.assign(this.answeredQuestions, {
          [option.questionId]: option.optionId,
        })
      );
    },
    selectOptionFromDropdown(e, option) {
      return this.selectOption({ ...option, optionId: e.target.value });
    },
    getUser() {
      const _token = localStorage.getItem("loanspotToken");
      if (!_token) {
        window.location.replace(AUTH_ROUTES.LOGIN);
      } else {
        this.token = `Bearer ${_token}`;
        return false;
      }
    },
    async getQuestions() {
      const response = await ApiInstance.get("/questions");
      if (response.data?.statusCode === 200) {
        return response.data.data;
      }
      return [];
    },
  },
};
</script>

<style lang="scss" scoped>
.question-wrapper {
  min-height: 400px;
  height: 100%;
  // min-width: 24rem;
}

.wrap {
  padding: 0 10% 80px;
  @media (min-width: 640px) {
  }
}
.main-wrap {
  width: 100%;
  max-width: 1440px;
  @media (min-width: 1440px) {
    padding: 0 10%;
  }
}
.logo {
  font-family: EuclidCircularSemiB;
  font-size: 1.5rem;
}
.form-wrap {
  width: 100%;
  max-width: 550px;
  &::after {
    // display: none;
    @media (min-width: 640px) {
      content: "";
      display: block;
      height: 8px;
      width: 11%;
      background: #1656c1;
      border-radius: 0 0 0 8px;
      margin-top: -8px;
    }
  }
}
.working--title {
  font-family: SohneHalbfett, sans-serif;
  font-size: 1.1rem;
}
.title {
  font-family: SohneHalbfett, sans-serif;
}
.radio-wrap {
  label {
    font-family: SohneLeicht, sans-serif;
    font-size: 0.875rem;
  }
}
.back--link {
  font-family: EuclidCircularReg;
}
</style>
